<template>
  <div>
    <v-app-bar v-bind="appBarBottomProps">
      <v-spacer />

      <template v-for="(item, index) in bottomMenus">
        <v-spacer v-if="index > 0"
                  :key="`bottomSpacer-${index}`"
        />

        <v-btn v-bind="bottomMenuProps"
               :key="`bottomMenu-${index}`"
               @click="menuEvent(item.name)"
        >
          <v-icon size="60">
            {{ item.icon }}
          </v-icon>
          <span class="bottom-bar-button__text">{{ item.text }}</span>
        </v-btn>
      </template>

      <v-spacer />

      <app-update-dialog v-model="showAppUpdateDialog" />
      <menu-dialog v-model="showMenuDialog" />
      <share-dialog v-model="showShareDialog" />
    </v-app-bar>

    <v-btn v-show="computedCurrentScroll > 100" class="scroll-top__button"
           color="#666666"
           width="80"
           height="80"
           elevation="0"
           dark
           fab fixed
           bottom right
           @click="$vuetify.goTo(0, {duration: 0})"
    >
      <v-icon size="50">
        $top
      </v-icon>
    </v-btn>
  </div>
</template>

<script>

import nativeCheck from '@/assets/functions/nativeCheck';
import MenuDialog from '@/components/common/dialogs/MenuDialog';
import AppUpdateDialog from '@/components/common/dialogs/AppUpdateDialog.vue';
import ShareDialog from '@/components/common/dialogs/ShareDialog.vue';
import { sync } from 'vuex-pathify';

export default {
  name: 'CommonBottomBar',
  components: { ShareDialog, AppUpdateDialog, MenuDialog },
  props: {
    appBarBottomProps: { type: Object, default: () => ({}) },
    currentScroll: { type: Number, default: 0 },
  },
  data: () => ({
    showAppUpdateDialog: false,
    showMenuDialog: false,
    bottomMenus: [
      { name: 'menu', icon: '$menu', text: '메뉴' },
      { name: 'reviews', icon: '$review', text: '리뷰' },
      { name: 'roundup', icon: '$roundup', text: '모아보기' },
      { name: 'kakaoTalk', icon: '$kakaoTalk', text: '카톡상담' },
      { name: 'favorites', icon: '$favorite', text: '관심상품' },
      { name: 'myPage', icon: '$myPage', text: 'MY' },
    ],
    bottomMenuProps: {
      plain: true,
      class: {
        'bottom-bar-button': true,
      },
    },
  }),
  computed: {
    showShareDialog: sync('share/showShareDialog'),
    nativeCheck,
    computedCurrentScroll () {
      return this.currentScroll;
    },
  },
  watch: {
    showMenuDialog (val) {
      document.querySelector('html').classList.toggle('application--dialog-opened', val);
    },
    $route () {
      // layout 변경없이 뒤로가기 앞으로가기 시 메뉴 dialog 닫히도록 설정
      this.showMenuDialog = false;
      document.querySelector('html').classList.toggle('application--dialog-opened', false);

      this.checkOldAndroidApp();
    },
  },
  mounted () {
    this.checkOldAndroidApp();
  },
  methods: {
    checkOldAndroidApp () {
      if (nativeCheck().isNative && nativeCheck().nativeType === 'android') {
        this.showAppUpdateDialog = true;
      }
    },
    menuEvent (name) {
      if (!name) {
        return;
      }

      const kakaoTalkLink = 'https://api.happytalk.io/api/kakao/chat_open?yid=%40%EC%98%A4%EB%A0%8C%EC%A6%88&site_id=5000001215&category_id=135410&division_id=135411';

      switch (name) {
        case 'menu' :
          this.showMenuDialog = true;
          break;

        case 'reviews' :
          this.$router.push({ name: 'reviews' });
          break;

        case 'roundup' :
          this.$router.push({ name: 'roundup' });
          break;

        case 'kakaoTalk':
          try {
            if (nativeCheck().isNative && (nativeCheck().nativeType === 'ios' || nativeCheck().nativeType === 'android')) {
              if (!window.webkit) {
                // eslint-disable-next-line no-undef
                NativeFunc.postMessage('openBrowser', '', kakaoTalkLink);
              } else {
                window.webkit.messageHandlers.NativeFunc.postMessage({
                  key: 'openBrowser',
                  callback: '',
                  value: kakaoTalkLink,
                });
              }
            } else {
              window.open(kakaoTalkLink);
            }
          } catch (err) {
            this.$dialog.message.error('문제가 발생했습니다. 관리자에게 문의해주세요.', { timeout: 1000 });
            console.log(err);
          }
          break;

        case 'favorites':
          this.$router.push({ name: 'favorites' });
          break;

        case 'myPage':
          this.$router.push({ name: 'my-page' });
          break;
      }
    },
  },
};
</script>
